// Equalize card heights regardless of what grid/section wraps them.
// The card's own CSS (align-items: stretch on .custom-sync-products__grid)
// only works when that specific grid class is the parent - but this card
// also renders inside sections we don't control (e.g. Shopify's native
// "You may also like" recommendations), which may wrap each card in its
// own individual container. Grouping by DOM parent alone breaks in that
// case (each card gets a different parent, so none are ever grouped
// together) - so instead we group by actual on-screen row position,
// which is reliable no matter what the wrapping markup looks like.
(function () {
  function equalizeSyncCardHeights() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.custom-sync-card'));
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = '';
    });

    void document.body.offsetHeight;

    var clusters = [];
    cards.forEach(function (card) {
      var top = Math.round(card.getBoundingClientRect().top);
      var cluster = clusters.filter(function (c) {
        return Math.abs(c.top - top) < 6;
      })[0];
      if (!cluster) {
        cluster = { top: top, cards: [] };
        clusters.push(cluster);
      }
      cluster.cards.push(card);
    });

    clusters.forEach(function (cluster) {
      if (cluster.cards.length < 2) return;
      var tallest = 0;
      cluster.cards.forEach(function (card) {
        tallest = Math.max(tallest, card.offsetHeight);
      });
      cluster.cards.forEach(function (card) {
        card.style.minHeight = tallest + 'px';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeSyncCardHeights);
  } else {
    equalizeSyncCardHeights();
  }

  window.addEventListener('load', equalizeSyncCardHeights);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeSyncCardHeights, 200);
  });
})();